import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import axios from "axios";
import RelationshipType from "../enums/RelationshipType";
import { axiosErrorHandler, groupBy } from "../../../swzutils";
const TenantPartnerSelect = ({ tenantId, disabled = false, allowClear = false, placeholder = "Select a partner", value, relationship, style, onChange, onPartnerSelected }) => {
    const [partners, setPartners] = useState([]);
    const [partnerOptions, setPartnerOptions] = useState([]);
    useEffect(() => {
        if (tenantId) {
            loadPartnerships();
        }
    }, [tenantId]);
    const loadPartnerships = () => {
        axios.get(`/admin/v1/tenants/${tenantId}/partnerships`, {
            params: {
                relationship: relationship?.key,
                limit: 1000
            }
        }).then(response => {
            const partners = response.data.results;
            const groupedPartners = groupBy(partners, (partnership) => partnership.relationTenant.id);
            const partnerOptions = [];
            Object.keys(groupedPartners).forEach((partnerId) => {
                const partnerName = groupedPartners[partnerId][0].relationTenant.name;
                const relationships = groupedPartners[partnerId].map(p => {
                    return RelationshipType.fromString(p.relationship)?.description;
                }).join(", ");
                partnerOptions.push({
                    label: `${partnerName} - ${relationships}`,
                    value: Number(partnerId)
                });
            });
            setPartners(partners);
            setPartnerOptions(partnerOptions);
        }).catch(axiosErrorHandler);
    };
    const onSelectChanged = (val) => {
        onChange && onChange(val);
        if (val && onPartnerSelected) {
            const partner = partners.find(t => t.relationTenant.id == val);
            if (partner) {
                onPartnerSelected(partner);
            }
        }
    };
    return (_jsx(Select, { disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onSelectChanged, value: value, showSearch: {
            optionFilterProp: ['label']
        }, options: partnerOptions }));
};
export default TenantPartnerSelect;
